import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    styleOverrides: {
        icon: {
            opacity: ".54",
            "&:hover": {
                opacity: ".87",
            },
            ".active > &": {
                opacity: ".87",
            },
        },
        image: {
            opacity: ".54",
            "&:hover": {
                opacity: ".87",
            },
            ".active > &": {
                opacity: ".87",
            },
        },
    },
})
